import { render, staticRenderFns } from "./SMSCampaign.vue?vue&type=template&id=b16bb410&"
import script from "./SMSCampaign.vue?vue&type=script&lang=ts&"
export * from "./SMSCampaign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports